module.exports = __webpack_public_path__ + "75fc073be5d2be7053e29f13d7426abd.svg";